// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPickDownloadHero-cls1_iyC","cls2":"LoswpPickDownloadHero-cls2_exk LoswpPickDownloadHero-cls1_iyC"};